import { useTranslation } from 'react-i18next';

/** Skip-to-content link · visible on Tab focus only.
 *  Per WCAG 2.1 SC 2.4.1 Bypass Blocks. */
export function SkipLink({ targetId = 'main-content' }: { targetId?: string }) {
  const { t } = useTranslation();
  return (
    <a
      href={`#${targetId}`}
      className="skip-link"
      style={{
        position: 'absolute',
        top: -40,
        left: 8,
        zIndex: 100,
        padding: '8px 14px',
        background: 'var(--accent)',
        color: 'white',
        fontFamily: 'Inter, sans-serif',
        fontSize: 13,
        fontWeight: 600,
        borderRadius: 'var(--r-md)',
        textDecoration: 'none',
        transition: 'top 0.18s ease',
      }}
      onFocus={(e) => (e.currentTarget.style.top = '8px')}
      onBlur={(e) => (e.currentTarget.style.top = '-40px')}
    >
      {t('skipLink')}
    </a>
  );
}
